// Diálogo de confirmación propio.
//
// Word para Windows corre el panel dentro de WebView2, que NO implementa
// window.confirm/alert/prompt: la llamada lanza "Function window.confirm is not
// supported" y aborta la acción entera. En Mac (WKWebView) sí funcionan, así que
// el fallo solo aparece en Windows y es invisible desarrollando en Mac.
//
// La API es la misma que la del navegador salvo que devuelve una promesa:
//   if (!(await askConfirm("¿Continuar?"))) return;

import { useState, useEffect } from "react";

type Pending = { text: string; resolve: (ok: boolean) => void };

let emit: ((p: Pending | null) => void) | null = null;

/** Pregunta al autor y espera su respuesta. Sin host montado, cancela. */
export function askConfirm(text: string): Promise<boolean> {
  return new Promise((resolve) => {
    if (!emit) {
      resolve(false);
      return;
    }
    emit({ text, resolve });
  });
}

/** Se monta una sola vez, en la raíz del panel. */
export default function ConfirmHost() {
  const [pending, setPending] = useState<Pending | null>(null);

  useEffect(() => {
    emit = setPending;
    return () => {
      emit = null;
    };
  }, []);

  if (!pending) return null;

  const answer = (ok: boolean) => {
    pending.resolve(ok);
    setPending(null);
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "var(--hi-velo)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        zIndex: 9999,
      }}
      onClick={() => answer(false)}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "var(--hi-papel)",
          border: "1px solid var(--hi-raya-2)",
          borderRadius: 12,
          padding: 16,
          maxWidth: 420,
          width: "100%",
          maxHeight: "80vh",
          overflowY: "auto",
          color: "var(--hi-tinta)",
          boxShadow: "0 12px 40px var(--hi-sombra)",
        }}
      >
        <div style={{ whiteSpace: "pre-wrap", fontSize: 13, lineHeight: 1.45 }}>{pending.text}</div>
        <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
          <button
            onClick={() => answer(false)}
            style={{
              flex: 1,
              padding: "10px 12px",
              borderRadius: 8,
              border: "1px solid var(--hi-raya-2)",
              background: "var(--hi-fondo)",
              color: "var(--hi-suave)",
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            Cancelar
          </button>
          <button
            onClick={() => answer(true)}
            autoFocus
            style={{
              flex: 1,
              padding: "10px 12px",
              borderRadius: 8,
              border: "none",
              background: "var(--hi-oficio)",
              color: "var(--hi-sobre-acento)",
              fontWeight: 800,
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            Continuar
          </button>
        </div>
      </div>
    </div>
  );
}
